/**
 * About marketing page (`/about`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 * Statically generated; no client-side data fetching or auth dependency.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';
import { Button } from '@/components/ui/button';

export default function AboutPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.about.title')}
        description={t('marketing.about.description')}
        path="/about"
      />

      <section className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.about.heading')}
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-xl text-muted-foreground">
          {t('marketing.about.subheading')}
        </p>
      </section>

      <section className="border-t bg-muted/30">
        <div className="container mx-auto max-w-3xl px-4 py-16 text-center">
          <h2 className="text-2xl font-semibold">{t('marketing.about.mission.title')}</h2>
          <p className="mt-4 text-lg text-muted-foreground">
            {t('marketing.about.mission.description')}
          </p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-16 text-center">
        <Button size="lg" asChild>
          <Link to="/getstarted">{t('marketing.about.cta')}</Link>
        </Button>
      </section>
    </MarketingLayout>
  );
}
